import type {DueDateUnit, Delay} from '../types';

export const DUE_UNIT_DAYS_ID = 'dd';
export const DUE_UNIT_HOURS_ID = 'HH';
export const DUE_UNIT_MINUTES_ID = 'mm';
export const DUE_UNIT_WEEKS_ID = 'ww';
export const DUE_UNIT_MONTHS_ID = 'MM';
export const DUE_UNIT_BUSINESS_DAYS_ID = 'bzd';
const DUE_UNIT_BUSINESS_HOURS_ID = 'bzh';

const DUE_UNIT_DAYS_NAME = 'days';
const DUE_UNIT_HOURS_NAME = 'hours';
const DUE_UNIT_MINUTES_NAME = 'minutes';
const DUE_UNIT_WEEKS_NAME = 'weeks';
const DUE_UNIT_MONTHS_NAME = 'months';
const DUE_UNIT_BUSINESS_DAYS_NAME = 'business days';
const DUE_UNIT_BUSINESS_HOURS_NAME = 'business hours';

export const getHumanReadableDueUnit = (dueUnit: DueDateUnit): string => {
    switch (dueUnit) {
        case DUE_UNIT_DAYS_ID:
            return DUE_UNIT_DAYS_NAME;
        case DUE_UNIT_HOURS_ID:
            return DUE_UNIT_HOURS_NAME;
        case DUE_UNIT_WEEKS_ID:
            return DUE_UNIT_WEEKS_NAME;
        case DUE_UNIT_MONTHS_ID:
            return DUE_UNIT_MONTHS_NAME;
        case DUE_UNIT_BUSINESS_DAYS_ID:
            return DUE_UNIT_BUSINESS_DAYS_NAME;
        case DUE_UNIT_BUSINESS_HOURS_ID:
            return DUE_UNIT_BUSINESS_HOURS_NAME;
        case DUE_UNIT_MINUTES_ID:
            return DUE_UNIT_MINUTES_NAME;
        default:
            return '';
    }
};

export const getHumanReadableSingularDueUnit = (dueUnit: DueDateUnit): string => {
    const pluralUnit = getHumanReadableDueUnit(dueUnit);

    // Sloppily slice off the 's' on the end.
    return pluralUnit.slice(0, -1);
};

const dueUnitIds: DueDateUnit[] = [
    DUE_UNIT_DAYS_ID,
    DUE_UNIT_HOURS_ID,
    DUE_UNIT_WEEKS_ID,
    DUE_UNIT_MINUTES_ID,
    DUE_UNIT_MONTHS_ID,
    DUE_UNIT_BUSINESS_DAYS_ID,
    DUE_UNIT_BUSINESS_HOURS_ID,
];

export function getDueUnitArray(plurality: 'singular' | 'plural') {
    return dueUnitIds.map((id) => ({
        id,
        value:
            plurality === 'singular'
                ? getHumanReadableSingularDueUnit(id)
                : getHumanReadableDueUnit(id),
    }));
}

export function getReadableDelay(delay: Delay) {
    const {timespan} = delay;
    const readableUnit = getReadableDelayUnit(delay);

    return `${timespan} ${readableUnit}`;
}

export function getReadableDelayUnit(delay: Delay) {
    const {unit, timespan} = delay;

    return timespan === 1 ? getHumanReadableSingularDueUnit(unit) : getHumanReadableDueUnit(unit);
}
